import { BoardFavoriteQuery } from './board-favorite-query.js'

export const entities = []
export const resolvers = [BoardFavoriteQuery]
